<script>
    import {faEnvelope, faPhone} from '@fortawesome/free-solid-svg-icons'
    import {faInstagram} from '@fortawesome/free-brands-svg-icons';
    import Fa from "svelte-fa";

</script>

<main>
    <div class="contactContainer">
        <div class="phone">
            <Fa icon={faPhone} color="#a4574e" size="2x"
                pull="left"/>
            <p>0157 / 58500652</p>
        </div>
        <div class="instaContainer">
            <a href="https://www.instagram.com/sektchen_mobil" target="_blank">
                <Fa icon={faInstagram} class="insta"
                    size="3x"
                    color="#a4574e"
                    fw
                    pull="right"
                />
            </a>
            <a href="mailto:cheers@sektchen-mobil.de">
                <Fa icon={faEnvelope}
                    size="3x"
                    color="#a4574e"
                    fw/>
            </a>
        </div>
    </div>
    <div>
        <img src="/assets/202308_Sektchen-Logo-rose.png" alt="Über uns"/>
    </div>
    <div class="textContainer">
        <br>
        <hr>
        <br>
        <p>Planst du einen Sektempfang, um einen ganz besonderen Moment im Kreis deiner Lieben zu feiern,
            möchtest aber nicht den Stress der Organisation übernehmen?</p>
        <strong class="highlight">Dann bist du hier genau richtig!</strong>
        <p>
            Alles, was du tun musst, ist mit uns in Kontakt zu treten, und wir kümmern uns darum, dass die Korken
            knallen.
            Mit unserer professionellen Unterstützung wird dein Sektempfang zu einem unvergesslichen Erlebnis.
        </p>
        <ul>
            <li>Wir übernehmen die gesamte Planung</li>
            <li>Sorgen für eine reibungslose Durchführung</li>
            <li>Lassen dich und deine Gäste den Augenblick in vollen Zügen genießen</li>
        </ul>

        <p> Egal, ob es sich um eine Hochzeit, eine Geburtstagsfeier, ein Jubiläum oder ein anderes besonderes Ereignis
            handelt,
            wir stehen dir zur Seite, um sicherzustellen, dass dein Sektempfang perfekt wird.
            Von der Auswahl
            der Sektsorten bis zur Gestaltung der Dekoration und dem Service am Tag der Veranstaltung,
            wir kümmern uns um jedes Detail, sodass du dich entspannen und feiern kannst.</p>
        <br>
        <div class="box-leistung">
        <h2>Unsere Leistungen</h2>
        <p>Ob unser Rundum-sorglos-Paket, bei dem wir alles für euren Sektempfang übernehmen oder das Ausleihen
            einzelner Utensilien - wir stehen für kreative Konzepte und individuelle Betreuung für den besonderen
            Moment.</p>
        <p>Das alles im Rems-Murr-Kreis sowie im Umkreis von 60 km.</p>
        <br>
        <div class="button-container">
            <a class="contact-button" href="mailto:cheers@sektchen-mobil.de">Anfrage</a>
        </div>
        </div>
        <br>
        <br>
        <p class="salutation">Cheers !</p>
        <br><br>
    </div>
</main>
<footer>
    <div class="mobilContactContainer">
        <a href="tel:015758500652">
            <Fa icon={faPhone}
                color="#a4574e"
                size="2x"
                fw/>
        </a>
        <a href="mailto:cheers@sektchen-mobil.de">
            <Fa icon={faEnvelope}
                color="#a4574e"
                size="2x"
                fw/>
        </a>
        <a href="https://www.instagram.com/sektchen_mobil" target="_blank">
            <Fa icon={faInstagram} class="insta"
                color="#a4574e"
                size="2x"
                fw
            />
        </a>
    </div>

</footer>

<style>
    .salutation {
        /*font-family: 'Barlow Condensed', sans-serif;*/
        /*font-family: 'Sofia', sans-serif;*/
        /*font-family: "Comfortaa", sans-serif;*/
        font-family: 'Lavishly Yours', cursive;
        font-size: 48px;
        color: #a4574e;
        margin: 0 0 0 32px;
    }

    .box-leistung {
        background-color: #fff;
        border: solid 2px #a4574e;
        border-radius: 16px;
        padding: 24px 60px;
        width: 80%;
        margin: 0 auto;
    }

    .button-container {
        display: flex;
    }

    .contact-button {
        text-decoration: none;
        color: #fff;
        background-color: #a4574e;
        padding: 12px 32px;
        border-radius: 12px;
    }

    h2 {
        color: #a4574e;
    }

    @media (min-width: 640px) {
        main {
            box-sizing: border-box;
            text-align: center;
            padding: 42px 1em;
            margin: 0 auto;
            background: radial-gradient(circle, #fff 40%, #e3c9c6);
        }

        .contactContainer {
            display: grid;
            grid-template-columns: 1fr 1fr;
            max-width: 800px; /* You can adjust the max-width as needed */
            margin: 0 auto; /* Center the container */
            gap: 20px;
        }

        .instaContainer {
            display: flex;
            justify-content: flex-end;
        }

        img {
            z-index: 9;
            width: 300px;
            margin-top: -64px;
        }

        div {
            color: black;
            margin-left: 12em;
            margin-right: 12em;
            display: block;
            align-items: center;
            justify-content: center;
            font-family: 'Barlow Condensed', sans-serif;
        }

        ul {
            list-style: none;
        }

        ul li::before {
            content: '🥂';
            margin-right: 8px;
            font-size: 1.2em;
        }

        ul li {
            font-weight: 600;
            line-height: 42px;
        }

        .phone {
            display: flex;
            min-width: max-content;
            box-sizing: border-box;
        }

        .phone p {
            padding-left: 8px;
            color: #a4574e;
        }

        footer {
            display: none;
        }

        .textContainer {
            text-align: justify;
            line-height: 24px;
        }

        p, li, strong {
            font-family: 'Barlow Condensed', sans-serif;
        }
    }

    @media (max-width: 640px) {
        main {
            box-sizing: border-box;
            text-align: center;
            background: radial-gradient(circle, #fff 40%, #e3c9c6);
            padding-bottom: 8px;
        }

        .textContainer {
            hyphens: auto;
            text-align: justify;
            line-height: 24px;
        }

        .highlight {
            margin-left: 16%;
        }

        p, ul {
            margin: 2em;
        }

        ul {
            list-style: none;
            padding: 0;
        }

        ul li {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            font-weight: 600;
            line-height: 1.6;
            margin-bottom: 8px;
        }

        ul li::before {
            content: '🥂';
            font-size: 1.2em;
            line-height: 1;
            margin-right: 0;
            width: 1.2em;
            text-align: center;
        }

        .box-leistung {
            padding: 16px 24px;
        }

        h2 {
            margin: 2rem;
        }

        .button-container {
            justify-content: center !important;
        }

        img {
            z-index: 9;
            width: 300px;
            align-self: center;
        }

        footer {
            background: #fff;
            position: sticky;
            bottom: 0;
        }

        .mobilContactContainer {
            display: flex;
            justify-content: space-evenly;
            padding: 2em;


        }

        .instaContainer, .contactContainer {
            display: none;
        }
    }
</style>